import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import {  IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'app-multiselect-v2',
  templateUrl: './multiselect-v2.component.html',
  styleUrls: ['./multiselect-v2.component.scss']
})
export class MultiselectV2Component implements OnInit {
  @Input() data: any;
    @Input() name: any;
    @Input() defauld: any;
    @Input() id: any;
    @Input() placeholder: any;
    @Input() disabled: Boolean;
    @Input() singleSelection: boolean;
    @Output() selected = new EventEmitter();
    dropdownSettings :IDropdownSettings;
    selectedDatas:any = [];
    constructor() { }
  
    ngOnInit() {
  
      this.dropdownSettings = {
        singleSelection: this.singleSelection,
        idField: 'id',
        textField: this.name,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true,
        // enableCheckAll: true
      };
    }
    onItemSelect(item: any) {
      let data = {
        status:"singleSelect",
        data:item
      }
      this.selected.emit(data);
    }
  
    onSelectAll(items: any) {
      let data = {
        status:"SelectAll",
        data:items
      }
      this.selected.emit(data);
    }
  
    onItemDeSelect(items: any){
      let data = {
        status:"singleDeselect",
        data:items
      }
      this.selected.emit(data);
    }
    onDeSelectAll(items: any){
      let data = {
        status:"unSelectAll",
        data:items
      }
      this.selected.emit(data);
    }

}
  
